<template>
  <div id="cat" v-cloak>
    <div class="vx-row mb-6">
      <div class="vx-col w-full mb-2">
        <vs-button @click="createDocument()" class="bg_l_green">
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("CreateDocument") }}
        </vs-button>
      </div>
    </div>
    <modify-popup
      :show="ModifyPopup"
      :model="modalModel"
      @finish="onfinish"
      @close="closeModifyPopup"
    ></modify-popup>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('Name'), sort: 'Name' },
            { title: $t('CustomerType'), sort: 'CustomerType' },
            { title: $t('SaleSystem'), sort: 'SaleSystem' },
            { title: $t('CreateOn'), sort: 'CreateOn' },
            { title: $t('Action') },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 20%">
              {{ row.name }}
            </td>
            <td style="width: 20%">
              <span v-if="row.partyType == 0">{{ $t("Individual") }}</span>
              <span v-if="row.partyType == 1">{{ $t("Legal") }}</span>
            </td>
            <td style="width: 20%">
              <span v-if="row.salesType == 0">{{ $t("InternalSale") }}</span>
              <span v-if="row.salesType == 1">{{ $t("EndUserSale") }}</span>
              <span v-if="row.salesType == 2">{{ $t("AgentSale") }}</span>
              <span v-if="row.salesType == 3">{{ $t("CorporateSale") }}</span>
            </td>
            <td style="width: 17%; direction: ltr">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
              }}
            </td>
            <td style="width: 20%">
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                @click.prevent="editDocument(row)"
                class="ml-4 d-inline"
              ></vs-button>
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="deletetDocument(row.id)"
                class="d-inline"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";

export default {
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "BusinessParties/api/DocumentSettingsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      allDocuments: "documentSetting/list",
    }),
  },

  methods: {
    ...mapActions({
      fetchDocuments: "documentSetting/fetch",
      removeDocument: "documentSetting/remove",
    }),
    ////Open Modal In Create Mode
    createDocument() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    //Open Modal In Edit Mode
    editDocument(model) {
      this.modalModel = {
        id: model.id,
        partyType: model.partyType,
        salesType: model.salesType,
        name: model.name,
        isRequired: model.isRequired,
      };
      this.ModifyPopup = true;
    },
    //Delete Method
    deletetDocument(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeDocument(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
